// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var EStatus;
(function (EStatus) {
    EStatus["PENDING"] = "PENDING";
    EStatus["APPROVED"] = "APPROVED";
    EStatus["DISAPPROVED"] = "DISAPPROVED";
})(EStatus || (EStatus = {}));
export var ETallySheetImportSourceFormat;
(function (ETallySheetImportSourceFormat) {
    ETallySheetImportSourceFormat["ESS_ENHANCED_XML"] = "ESS_ENHANCED_XML";
    ETallySheetImportSourceFormat["CANONICAL_CSV"] = "CANONICAL_CSV";
})(ETallySheetImportSourceFormat || (ETallySheetImportSourceFormat = {}));
export var ETallySheetImportChangeType;
(function (ETallySheetImportChangeType) {
    ETallySheetImportChangeType["NEW"] = "NEW";
    ETallySheetImportChangeType["CHANGED"] = "CHANGED";
    ETallySheetImportChangeType["UNCHANGED"] = "UNCHANGED";
})(ETallySheetImportChangeType || (ETallySheetImportChangeType = {}));
export var ETallySheetImportStatus;
(function (ETallySheetImportStatus) {
    ETallySheetImportStatus["PENDING_REVIEW"] = "PENDING_REVIEW";
    ETallySheetImportStatus["APPROVED"] = "APPROVED";
    ETallySheetImportStatus["DISAPPROVED"] = "DISAPPROVED";
    ETallySheetImportStatus["FAILED_VALIDATION"] = "FAILED_VALIDATION";
    ETallySheetImportStatus["CONFLICTED"] = "CONFLICTED";
})(ETallySheetImportStatus || (ETallySheetImportStatus = {}));
export var ETallySheetImportItemStatus;
(function (ETallySheetImportItemStatus) {
    ETallySheetImportItemStatus["PENDING_REVIEW"] = "PENDING_REVIEW";
    ETallySheetImportItemStatus["APPROVED"] = "APPROVED";
    ETallySheetImportItemStatus["DISAPPROVED"] = "DISAPPROVED";
    ETallySheetImportItemStatus["CONFLICTED"] = "CONFLICTED";
})(ETallySheetImportItemStatus || (ETallySheetImportItemStatus = {}));
export var ETallySheetImportReviewDecision;
(function (ETallySheetImportReviewDecision) {
    ETallySheetImportReviewDecision["APPROVE"] = "APPROVE";
    ETallySheetImportReviewDecision["DISAPPROVE"] = "DISAPPROVE";
})(ETallySheetImportReviewDecision || (ETallySheetImportReviewDecision = {}));
